import { AppBar, Box } from '@mui/material';
import styled from 'styled-components';

export const Footer = styled.footer`
  width: -webkit-fill-available;
  background-color: #fff;
  padding: 15px;
  position: relative;
  bottom: 0;
  border-top: 1px solid #d2d6de;
`;

export const SocialIcons = styled.div`
  color: #fff;

  > * {
    transition: 0.2s ease-in-out;
    &:hover {
      color: #000080;
      cursor: pointer;
    }
  }

  > * + * {
    margin-left: 10px;
  }
`;

export const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  margin-top: 20px;
  border-top: 1px solid rgb(255 255 255 / 35%);
  padding-top: 20px;
  margin-bottom: 0;
`;

export const Links = styled.div``;

export const FooterContainer = styled(Box)`
  height: 60px;
  align-items: center;
`;

export const FooterRow = styled(Box)`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
`;

export const FazendaInfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 500;
  padding: 0 10px;
`;

export const Header = styled(AppBar)`
  background-color: #fff !important;
  color: #000080 !important;
  box-shadow: rgba(25, 31, 40, 0.15) 0px 6px 24px 0px !important;
  opacity: 0.98;

  & button {
    font-size: small;
    font-weight: bold;
  }
`;

export const DeleteModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
